import React, { ChangeEvent, useState, useEffect } from 'react';
import { Grid, Card, CardHeader, CardContent, FormGroup, TextField, makeStyles } from '@material-ui/core';

import { Period, Team } from '../../../utils/types';
import Periods from '../Periods';
import { fetchAppConfigByProfileName } from '../../common/Appconfig';

const useStyles = makeStyles((theme) => ({
	// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
	highlightDetailsCard: ({ height }: StyleProps) => ({
		marginBottom: theme.spacing(2),
		height
	}),
	inputField: {
		paddingBottom: theme.spacing(2)
	}
}));

type StyleProps = { height: string | number };

const HighlightDetailsEditor: React.FC<HighlightDetailsEditorProps> = (props) => {
	const {
		gameId,
		airingId,
		teams,
		sport,
		gameStartTime,
		height,
		id,
		onChange,
		onPeriodAdd,
		onPeriodDelete,
		onPeriodsDelete,
		onPeriodUpdate,
		periods,
		editorialPeriodPlayIds,
		draftPeriodPlayIds,
		hidePeriodDetails,
		type
	} = props;
	const classes = useStyles({ height: height || 'auto' });
	useEffect(() => {
		const getDropdownOptionsConfig = async (): Promise<void> => {
			const appConfigContent = await fetchAppConfigByProfileName('mgmt_ui_appconfig_dropdown_profile');
			if (appConfigContent) setDropDownOptions(JSON.parse(appConfigContent));
		};
		getDropdownOptionsConfig();
	}, []);
	const [dropDownOptions, setDropDownOptions] = useState<Record<string, unknown>>({});

	return (
		<>
			<Card className={classes.highlightDetailsCard}>
				<CardHeader title='New highlight' />
				<CardContent>
					<Grid container>
						<Grid item xs={12}>
							<FormGroup>
								<TextField id='id' label='ID' name='id' className={classes.inputField} value={id} disabled fullWidth />
								<TextField disabled id='type' label='Type' name='type' className={classes.inputField} value={type} onChange={onChange} fullWidth />
								<TextField
									disabled
									id='gameId'
									label='Game ID'
									name='gameId'
									className={classes.inputField}
									value={gameId}
									onChange={onChange}
									fullWidth
								/>
								{airingId && (
									<TextField
										disabled
										id='airingId'
										label='Airing ID'
										name='airingId'
										className={classes.inputField}
										value={airingId}
										onChange={onChange}
										fullWidth
									/>
								)}
							</FormGroup>
						</Grid>
					</Grid>
				</CardContent>
			</Card>
			<Periods
				dropDownOptions={dropDownOptions}
				teams={teams}
				sport={sport}
				gameStartTime={gameStartTime}
				periods={periods && periods.items ? periods.items : []}
				checkPlayIdOrigin={true}
				editorialPeriodPlayIds={editorialPeriodPlayIds ?? []}
				draftPeriodPlayIds={draftPeriodPlayIds ?? []}
				hideDetails={hidePeriodDetails}
				gameTitle={gameId}
				highlightId={id}
				onRowAdd={onPeriodAdd}
				onRowDelete={onPeriodDelete}
				onAllDelete={onPeriodsDelete}
				onRowUpdate={onPeriodUpdate}
			/>
		</>
	);
};

type HighlightDetailsEditorProps = {
	id: string;
	gameId?: string | null;
	airingId?: string | null;
	teams?: Team[] | null;
	sport?: string | null;
	gameStartTime?: string | undefined;
	height?: string | number;
	periods?: { items?: Period[] } | null;
	editorialPeriodPlayIds?: string[] | null;
	draftPeriodPlayIds?: string[] | null;
	hidePeriodDetails?: boolean | null;
	type?: string | null;
	onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
	onPeriodAdd?: (newData: Period) => Promise<unknown>;
	onPeriodUpdate?: (newData: Period, oldData?: Period) => Promise<unknown>;
	onPeriodDelete?: (oldData: Period) => Promise<unknown>;
	onPeriodsDelete?: () => Promise<unknown>;
};

export default HighlightDetailsEditor;
